/** biome-ignore-all lint/a11y/noStaticElementInteractions: <svg> */
import { useMemo, useState } from 'react';
import type { HeatmapCellData } from '@/data';
import { cn } from '@/libs';
import { getCellColor, getFillColor } from '../utils';
interface UptimeHeatmapProps {
  heatmapData: HeatmapCellData[][];
}
export const Heatmap: React.FC<UptimeHeatmapProps> = ({
  heatmapData
}) => {
  const [hoveredCell, setHoveredCell] = useState<HeatmapCellData | null>(null);
  const [tooltipPosition, setTooltipPosition] = useState({
    x: 0,
    y: 0
  });

  // Handle cell hover
  const handleCellHover = (cell: HeatmapCellData, event: React.MouseEvent) => {
    setHoveredCell(cell);
    setTooltipPosition({
      x: event.clientX,
      y: event.clientY
    });
  };

  // Generate hour labels (0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22)
  const hourLabels = Array.from({
    length: 12
  }, (_, i) => i * 2);

  // Generate date labels (show every 10 days)
  const dateLabels = useMemo(() => {
    const labels: string[] = [];
    const today = new Date();
    for (let i = 0; i < 90; i += 10) {
      const date = new Date(today);
      date.setDate(today.getDate() - (89 - i));
      labels.push(date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      }));
    }
    return labels;
  }, []);
  return <>
      <div className='relative overflow-x-visible'>
        <div className='flex'>
          <div className='flex w-full flex-col'>
            <div className='mb-1 flex h-4'>
              {dateLabels.map((label, index) => <div className='text-center text-foreground/40 text-xs' key={index} style={{
              width: `${90 * 4}px`,
              marginLeft: index === 0 ? `${index * 10 * 4}px` : `${10 * 4}px`
            }}>
                  {label}
                </div>)}
            </div>
            {/* {hourLabels.map((hour, rowIndex) => (
              <div className='mb-1 flex' key={hour}>
                {heatmapData.map((column, colIndex) => {
                  const cell = column[rowIndex]
                  return (
                    <button
                      className={cn(
                        'mr-1 aspect-square w-[calc(100%/90)] cursor-pointer rounded-full transition-all duration-200',
                        getCellColor(cell),
                      )}
                      key={`${colIndex}-${rowIndex}`}
                      onMouseEnter={(e) => handleCellHover(cell, e)}
                      onMouseLeave={() => setHoveredCell(null)}
                    />
                  )
                })}
              </div>
             ))} */}
            <svg className='w-full' viewBox='0 0 90 12'>
              {hourLabels.map((hour, rowIndex) => <g key={hour}>
                  {heatmapData.map((column, colIndex) => {
                const cell = column[rowIndex];
                return <circle className={cn(getFillColor(cell))} cx={colIndex + 0.5} cy={rowIndex + 0.5} key={`${colIndex}-${rowIndex}`} onMouseEnter={e => handleCellHover(cell, e)} onMouseLeave={() => setHoveredCell(null)} r='0.4' />;
              })}
                </g>)}
            </svg>
          </div>
        </div>
      </div>
      {hoveredCell && <div className='fixed z-50 max-w-xs rounded-lg bg-background-deep/60 p-3 text-foreground backdrop-blur' style={{
      left: tooltipPosition.x + 10,
      top: tooltipPosition.y - 10,
      pointerEvents: 'none'
    }}>
          <div className='text-sm'>
            <div className='mb-1 font-semibold'>{hoveredCell.date}</div>
            <div className='mb-1 text-foreground/70'>
              {hoveredCell.hour}:00 - {hoveredCell.hour + 2}:00
            </div>
            <div className='mb-1 flex items-center gap-2'>
              <div className={cn('size-3 rounded-sm', getCellColor(hoveredCell))} />
              <span className='font-medium capitalize'>
                {hoveredCell.status === 'no-data' ? 'No Data' : hoveredCell.status}
              </span>
            </div>
            {hoveredCell.count > 0 && <>
                <div className='text-foreground/70'>
                  {hoveredCell.count} checks
                </div>
                <div className='text-foreground/70'>
                  {hoveredCell.avgResponseTime.toFixed(1)}ms avg response
                </div>
              </>}
          </div>
        </div>}
    </>;
};